import { axiosGetWithCookies, axiosPutWithCookies } from './helper';

export const fetchDepartmentList = ({
  archived = false,
  from = 0,
  limit = 50,
  search,
}) => {
  let query = `/users/departments?limit=${limit}`;
  if (archived) query += `&includeArchived=${archived}`;
  if (from !== undefined) query += `&from=${from}`;
  if (search) query += `&search=${search}`;
  return axiosGetWithCookies(query);
};

export const fetchDepartmentById = ({ id }) =>
  axiosGetWithCookies(`/users/departments/${id}`);

export const updateOrCreateDepartment = ({ department }) => {
  const query = `/users/departments`;
  return axiosPutWithCookies(query, { data: department });
};
export const fetchGlobalDepartments = () => {
  const query = `/users/departments/id-name-map`;
  return axiosGetWithCookies(query);
};
